<template>
  <svg height="66" viewBox="0 0 66 66" width="66" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
      <circle cx="32" cy="32" r="32" stroke="#fff" stroke-width="2" />
      <path d="m35 24 10 16h-20z" fill="#fff" transform="matrix(0 1 -1 0 67 -3)" />
    </g>
  </svg>
</template>

<script>
export default {};
</script>
